import { MessageSquareIcon } from "lucide-react"
import { useTranslation } from "react-i18next"
import { OnboardingEmptyState } from "@/components/System"

const LockPanel = () => {
  const { t } = useTranslation()

  const steps = [
    { title: t("workspace.agentPlayground.lockPanel.steps.name") },
    { title: t("workspace.agentPlayground.lockPanel.steps.instructions") },
    { title: t("workspace.agentPlayground.lockPanel.steps.test") },
  ]

  return (
    <div className="flex h-full items-start justify-center pt-24">
      <OnboardingEmptyState
        icon={MessageSquareIcon}
        title={t("workspace.agentPlayground.lockPanel.title")}
        description={t("workspace.agentPlayground.lockPanel.description")}
        steps={steps}
        className="max-w-md"
      />
    </div>
  )
}

export default LockPanel
